module.exports = __webpack_public_path__ + "credito-15-m-xf7.png";